import { BaseComponent } from "../../../components/BaseComponent";
import { Plus } from "../../../components/Icon";
import React from "react";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { List } from "../../../components/List";
import { Button } from "../../../components/Buttons";
import styled from "styled-components";
import { Modal, ModalControls } from "../../../components/Modal";
import { InvoiceRelationSourceListItem } from "./InvoiceRelationSourceListItem";
import { InvoiceRelationSourceDetails } from "./InvoiceRelationSourceDetails";

const STATE = {
  add: false,
  delete: null,
  items: [],
};

const Container = styled.div``;

class InvoiceRelationSourceContainerComp extends BaseComponent {

  constructor(props) {
    super(props);
  }

  get items() {
    return this.props.items;
  }

  onCloseDelete() {
    this.setState(prev => {
      return {
        ...prev,
        delete: false,
      }
    })
  }

  onClickAdd() {
    this.setState(prev => {
      return {
        ...prev,
        addSource: true,
      }
    })
  }

  onDeleteItem(id) {
    this.setState(prev => {
      return {
        ...prev,
        delete: id,
      };
    });
  }

  onConfirmDeleteItem() {
    this.props.onDeleteSource(this.state.delete);
    this.setState(prev => {
      return {
        ...prev,
        delete: false,
      };
    });
  }

  onCloseSource() {
    this.setState(prev => {
      return {
        ...prev,
        addSource: false,
      };
    });
  }

  onAddSource(source) {
    this.setState(prev => {
      return {
        ...prev,
        addSource: false,
      };
    });
    this.props.onAddSource(source);
  }

  renderDeleteSource() {
    if (!this.state.delete) return '';

    return (
      <Modal title={this.lbl('confirm')}>
        <ModalControls>
          <Button primary onClick={this.onConfirmDeleteItem.bind(this)}>
            {this.lbl('ok')}
          </Button>
          <Button onClick={this.onCloseDelete.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderAddSource() {
    if (!this.state.addSource) return '';

    return (
      <InvoiceRelationSourceDetails onAdd={this.onAddSource.bind(this)} onClose={this.onCloseSource.bind(this)} />
    );
  }

  render() {
    return (
      <Container>
        <List>
          {this.items?.map(i => <InvoiceRelationSourceListItem key={i.id} source={i} onDelete={this.onDeleteItem.bind(this)} />)}
        </List>
        <Button onClick={this.onClickAdd.bind(this)}>
          <Plus />
          {this.lbl('add')}
        </Button>
        {this.renderDeleteSource()}
        {this.renderAddSource()}
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const InvoiceRelationSourceContainer = compose(
  withConnect,
  withRouter,
)(InvoiceRelationSourceContainerComp);
